import { createSlotRecipe } from './runtime.js';

const cardStackConfig = {"name":"cardStack","className":"card-stack","slots":["stack","item","content"],"defaultVariants":{"itemOverflow":"hidden","itemSurface":"default"},"variantMap":{"itemOverflow":["hidden","visible"],"itemSurface":["default","plain"]}}

export const cardStack = /* @__PURE__ */ createSlotRecipe(cardStackConfig)